import React from "react";

interface TabsProps {
  tabs: { id: string; label: string; count?: number }[];
  active: string;
  onChange: (id: string) => void;
}

export function Tabs({ tabs, active, onChange }: TabsProps) {
  return (
    <div className="flex gap-1 mb-6" style={{ borderBottom: "1px solid var(--c-border)" }}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className="px-4 py-2.5 text-[13px] font-medium transition-all duration-200 -mb-px"
          style={{
            color: active === tab.id ? "var(--c-text)" : "var(--c-text-faint)",
            borderBottom: `2px solid ${active === tab.id ? "var(--c-primary)" : "transparent"}`,
          }}
        >
          {tab.label}
          {tab.count !== undefined && (
            <span
              className="ml-2 text-[10px] px-1.5 py-0.5 rounded-full"
              style={{
                backgroundColor: active === tab.id ? "var(--c-primary-subtle)" : "var(--c-active)",
                color: active === tab.id ? "var(--c-primary)" : "var(--c-text-faint)",
              }}
            >
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
